import { useQuery } from '@tanstack/react-query'
import { getTopologyStats } from '../../api/topology.ts'

interface StatusBarProps {
  coordinates?: { lat: number; lng: number } | null
}

export function StatusBar({ coordinates }: StatusBarProps) {
  const { data: stats } = useQuery({
    queryKey: ['topology-stats'],
    queryFn: getTopologyStats,
    refetchInterval: 60_000,
  })

  return (
    <div className="h-7 bg-gray-100 border-t border-gray-200 flex items-center px-4 gap-6 text-xs text-gray-600 shrink-0">
      {stats && (
        <>
          <span>Substations: <strong>{stats.substation_count}</strong></span>
          <span>Feeders: <strong>{stats.feeder_count}</strong></span>
          <span>Transformers: <strong>{stats.transformer_count}</strong></span>
          <span>Meters: <strong>{stats.meter_count}</strong></span>
          <span>
            Verified: <strong className="text-green-600">{stats.verified_meter_count}</strong>
            {' / '}
            Unlinked: <strong className="text-orange-500">{stats.meters_without_transformer}</strong>
          </span>
        </>
      )}
      <span className="ml-auto font-mono text-gray-400">
        {coordinates
          ? `${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`
          : '--.--, --.--'}
      </span>
    </div>
  )
}
